export function convertGoogleTimeStampsToDates(prop) {
  if (
    prop !== undefined &&
    prop !== null &&
    Object.keys(prop).length === 2 &&
    prop.hasOwnProperty("nanoseconds") &&
    prop.hasOwnProperty("seconds")
  ) {
    return new Date(prop.seconds * 1000);
  } else {
    return prop;
  }
}
